import api from "../../api";

class Lanches {
  index() {
   return api.get('lanches');
  }

  store(data) {
    return api.post('lanches', data);
  }

  show(id) {
    return api.get(`lanches/${id}`);
  }

  update(id, data) {
    return api.put(`lanches/${id}`, data);
  }
}

export default new Lanches();
